import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/user/auth'
import { getResponse, getError } from '@/composables/api'
import { useToastsStore } from '@/stores/notifications/toasts'
import { useGinnelStore } from '@/stores/ginnels/ginnel'
import axios from 'axios'

export const useGinnelTagsStore = defineStore({
   id: 'ginnel-tags',
   state: () => ({
      tags: [],

      storeGinnel: useGinnelStore(),
      storeAuth: useAuthStore(),
      storeToasts: useToastsStore(),
   }),
   actions: {
      getTags(ginnelID) {
         axios.get('ginnel/tags', { params: { ginnel_id: ginnelID } })
         .then((response) => {
            this.tags = getResponse(response)
         })
      },
      attach(params) {
			axios.post('ginnel/tags', params)
         .then(response => {
            if(params?.attachment?.type == 'file') {
               this.storeGinnel.ginnel.files.map(file => {
                  if(file.file_id == params?.attachment?.type_id) {
                     file.tags = getResponse(response)
                  }
               })
            }  else {
               this.storeGinnel.ginnel.ginnel.tags = getResponse(response)
            }
            // this.storeGinnel.get(params?.attachment?.ginnel_id, true)
            this.storeToasts.sendToast('A tag has been attached', 'success')
			})
      },
   }
})